import { type CoreMessageType, type SendableMessageType } from "@sendbird/uikit-react/types/utils";
import { type CustomMessageTypes } from "@src/appV2/Chat/type";
import type React from "react";

import {
  isChatMessageWithText,
  isSendBirdGroupChannel,
  type PlacementChatMetadata,
} from "../types";
import { PlacementChatMessageLayout } from "./PlacementChatMessageLayout";

export function PlacementSentByClipboardChatMessage({
  message,
  channel,
  customType,
}: {
  message: CoreMessageType;
  channel: unknown;
  customType: CustomMessageTypes;
}): React.ReactElement {
  const chatMessage = (
    typeof message === "object" && message !== null
      ? message
      : // FIXME: Automatically disabled during ESLint config update
        JSON.parse(JSON.stringify(message))
  ) as unknown;

  const chatChannel = (
    typeof channel === "object" && channel !== null
      ? channel
      : // FIXME: Automatically disabled during ESLint config update
        JSON.parse(JSON.stringify(channel))
  ) as unknown;

  if (!isChatMessageWithText(chatMessage) || !isSendBirdGroupChannel(chatChannel)) {
    return null as unknown as React.ReactElement;
  }

  if (chatMessage.customType === customType && chatChannel.customType === "placements") {
    return (
      <PlacementChatMessageLayout message={chatMessage.message.trim()} />
    ) as unknown as React.ReactElement;
  }

  // the message user could be the managing (parent) facility, but this would be confusing for users
  // so we overwrite the name to show the true facility name
  const placementChatMetadata = chatChannel.cachedMetaData as PlacementChatMetadata;
  const { sender } = message as SendableMessageType;
  if (sender && placementChatMetadata.facilityName) {
    sender.nickname = placementChatMetadata.facilityName;
    sender.friendName = placementChatMetadata.facilityName;
  }

  return null as unknown as React.ReactElement;
}
